import React from "react";
import { IconButton, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import WebMAPToolTip from "components/WebMAPToolTip";

const StyledPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const StyledButton = styled(IconButton)(() => ({
  minWidth: "unset",
}));

export default function PluginControlButton({
  icon,
  onClick,
  title,
  abstract,
}) {
  return (
    <WebMAPToolTip title={`${title}: ${abstract}`}>
      <StyledPaper>
        <StyledButton aria-label={title} onClick={onClick}>
          {icon}
        </StyledButton>
      </StyledPaper>
    </WebMAPToolTip>
  );
}
